import './WLED.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class WLED extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

}
